import type {
  IInvoiceRepository,
  InvoiceListQuery,
} from '@domain/data-contracts/invoice-repository.interface';
import type { Invoice } from '@domain/models/invoice.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class InvoicesService {
  public constructor(private readonly repo: IInvoiceRepository) {}

  public list(query: InvoiceListQuery): Promise<PagedResult<Invoice>> {
    return this.repo.list(query);
  }
}
